export default "__VITE_ASSET__UksO60ud__"